module.exports = __webpack_public_path__ + "static/media/send.4849144c.svg";